module.exports = __webpack_public_path__ + "static/media/adventure-drivers.5ce94b56.jpg";